import { z } from 'zod';
import { SiteConfig } from '../schemas/site.js';

export type Site = z.infer<typeof SiteConfig> & {
  active: boolean;
  created_at: string;
  updated_at: string;
};

const SiteRow = SiteConfig.extend({
  active: z.boolean(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const SITES: readonly Site[] = [
  {
    site_code: 'pl',
    host: 'wandero.pl',
    default_lang: 'pl',
    supported_langs: ['pl', 'en'],
    default_currency: 'PLN',
    country_code: 'PL',
    brand_settings: { primary_color: '#1a73e8', logo: 'wandero-pl.svg' },
    active: true,
    created_at: '2026-01-01T00:00:00.000Z',
    updated_at: '2026-01-01T00:00:00.000Z',
  },
  {
    site_code: 'de',
    host: 'wandero.de',
    default_lang: 'de',
    supported_langs: ['de', 'en'],
    default_currency: 'EUR',
    country_code: 'DE',
    brand_settings: { primary_color: '#1a73e8', logo: 'wandero-de.svg' },
    active: true,
    created_at: '2026-01-02T00:00:00.000Z',
    updated_at: '2026-01-02T00:00:00.000Z',
  },
  {
    site_code: 'cz',
    host: 'wandero.cz',
    default_lang: 'cs',
    supported_langs: ['cs', 'en'],
    default_currency: 'CZK',
    country_code: 'CZ',
    brand_settings: { primary_color: '#1a73e8', logo: 'wandero-cz.svg' },
    active: true,
    created_at: '2026-01-03T00:00:00.000Z',
    updated_at: '2026-01-03T00:00:00.000Z',
  },
] as const;

// Validate at module load time
SITES.forEach((s) => SiteRow.parse(s));
